module.exports = "<div class=\"mainfe\" id=\"olr-mainfe\" ng-controller= \"MainController as mainCtrl\">  \n\t<header>\n\t\t<div ng-include src= \"'header.htm'\"></div>\n\t</header>\n\t<div ng-if=\"$root.showSpinner\" class=\"overlay\">\n\t\t<div style=\"margin-left:47%;margin-top:300px;\">\n\t\t\t<md-progress-circular class=\"md-primary md-hue-1\" md-diameter=\"30\"></md-progress-circular>\n\t\t</div>\n\t</div>\n\n \t<div style=\"position:relative;top:70px\" id=\"main\">\n  \t<div ng-include src= \"'sidenav.htm'\"></div>\n\t<div ui-view name=\"content\"></div>\n  </div>\n  <footer>\n  </footer>\n</div>\n\n";


/*****************
 ** WEBPACK FOOTER
 ** ./src/olr-mainfe/main-template.html
 ** module id = 265
 ** module chunks = 1
 **/